import type { MarketVariants } from '@/lib/i18n'

export type Slide9PracticeCopy = {
  // Email mockup
  senderName: string
  senderEmail: string
  /** Single letter shown in the sender avatar circle. */
  senderInitial: string
  emailHeadline: string
  emailBody1: string
  emailBody2: string
  ctaLabel: string

  // Question + choices
  question: string
  choice1Label: string
  choice1Feedback: string
  choice2Label: string
  choice2Feedback: string
  choice3Label: string
  choice3Feedback: string
  choice4Label: string
  choice4Feedback: string
}

export const copy: MarketVariants<Slide9PracticeCopy> = {
  US: {
    senderName: 'PayPal Security',
    senderEmail: 'no-reply@paypa1-secure.com',
    senderInitial: 'P',
    emailHeadline: 'Unusual sign-in detected',
    emailBody1:
      'We noticed a sign-in to your account from an unrecognized device in Lagos, Nigeria.',
    emailBody2:
      'If this was not you, secure your account immediately to prevent unauthorized access.',
    ctaLabel: 'Secure Your Account Now',

    question: 'You receive this email. What do you do?',
    choice1Label: 'Click "Secure Your Account Now" in the email',
    choice1Feedback:
      'That button could lead to a fake login page designed to steal your real password.',
    choice2Label:
      'Open the PayPal app or website directly and check your activity',
    choice2Feedback:
      'You chose a channel you control. If there really is a problem, you will see it here.',
    choice3Label: 'Call the support number listed in the email',
    choice3Feedback:
      'A scammer who sent the email also controls the number inside it. That is not independent.',
    choice4Label: 'Reply to the email and ask if it is legitimate',
    choice4Feedback:
      'Replying keeps you inside their channel. A scammer who sent the email controls the reply too.',
  },
  // Qatar: PayPal is a marginal brand there; Amazon is the recognizable one
  // and keeps the look-alike-domain lesson (amaz0n with a zero).
  QA: {
    senderName: 'Amazon Security',
    senderEmail: 'no-reply@amaz0n-secure.com',
    senderInitial: 'A',
    emailBody1:
      'We noticed a sign-in to your account from an unrecognized device in Bucharest, Romania.',
    choice2Label:
      'Open the Amazon app or website directly and check your activity',
  },
  ar: {
    senderName: 'فريق أمان أمازون',
    senderEmail: 'no-reply@amaz0n-secure.com',
    senderInitial: 'A',
    emailHeadline: 'رُصد تسجيل دخول غير معتاد',
    emailBody1:
      'لاحظنا تسجيل دخول إلى حسابك من جهاز غير معروف في بوخارست، رومانيا.',
    emailBody2:
      'إذا لم تكن أنت، فقم بتأمين حسابك فوراً لمنع أي وصول غير مصرّح به.',
    ctaLabel: 'أمّن حسابك الآن',

    question: 'وصلتك هذه الرسالة. ماذا تفعل؟',
    choice1Label: 'أضغط على "أمّن حسابك الآن" في الرسالة',
    choice1Feedback:
      'قد يقودك هذا الزر إلى صفحة تسجيل دخول مزيّفة مصمَّمة لسرقة كلمة مرورك الحقيقية.',
    choice2Label:
      'أفتح تطبيق أمازون أو موقعه مباشرة وأراجع نشاط حسابي',
    choice2Feedback:
      'اخترت قناة تتحكم بها أنت. إن كانت هناك مشكلة فعلاً، فستراها هنا.',
    choice3Label: 'أتصل برقم الدعم المذكور في الرسالة',
    choice3Feedback:
      'المحتال الذي أرسل الرسالة يتحكم أيضاً بالرقم الموجود فيها. هذا ليس تحققاً مستقلاً.',
    choice4Label: 'أردّ على الرسالة وأسأل إن كانت حقيقية',
    choice4Feedback:
      'الردّ يبقيك داخل قناتهم. والمحتال الذي أرسل الرسالة يتحكم بالردّ أيضاً.',
  },
}
